export const colors = {
  black: '#000',
  green: '#33ff33',
  red: '#f00',
  white: '#fff',
  lightGrey: '#aaa',
}

export const styles = {
  chartOptionContainer: {
    border: '3px solid white',
    width: '30%',
    height: '2.5rem',
    margin: '1rem 2rem',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-evenly',
    alignItems: 'center',
  },
  chartOption: {
    cursor: 'pointer',
    boxSizing: 'border-box',
    padding: '0 0.5rem',
    width: '25%',
    textAlign: 'center',
  },
}
